// Builds a shareable URL from the current location, replacing only the
// ?cam= query parameter. Other params (id, embed, future utm_*, etc.) are
// preserved so links keep working when shared verbatim.
//
// Accepts both absolute URLs (typical: window.location.href) and relative
// paths (e.g. '/embed/<id>?ref=a'). Relative paths are resolved against the
// current document origin when running in a browser, falling back to
// 'http://localhost' for SSR/tests so the encoder never throws.
export function buildShareUrl(href: string, encodedCam: string): string {
  const base =
    typeof window !== 'undefined' && window.location ? window.location.origin : 'http://localhost';
  const url = new URL(href, base);
  url.searchParams.set('cam', encodedCam);
  return url.toString();
}
